export * from './domain';
export * from './dto';
export * from './builders';
export var createTicketsSlaInsightsApi = function (baseUrl, http) {
    var ticketsUrl = baseUrl + "/analytics/tickets";
    var slaUrl = ticketsUrl + "/sla";
    return {
        getOverview: function (dto) { return http.post(ticketsUrl + "/overview", dto); },
        getComplianceCumulative: function (dto) { return http.post(slaUrl + "/compliance/cumulative", dto); },
        getComplianceHistogram: function (dto) { return http.post(slaUrl + "/compliance/histogram", dto); },
        getElapsedTimeCumulative: function (dto) { return http.post(slaUrl + "/elapsedTime/cumulative", dto); },
        getElapsedTimeHistogram: function (dto) { return http.post(slaUrl + "/elapsedTime/histogram", dto); },
        getMissCountCumulative: function (dto) { return http.post(slaUrl + "/missCount/cumulative", dto); },
        getMissCountHistogram: function (dto) { return http.post(slaUrl + "/missCount/histogram", dto); },
        getMissTimeCumulative: function (dto) { return http.post(slaUrl + "/missTime/cumulative", dto); },
        getMissTimeHistogram: function (dto) { return http.post(slaUrl + "/missTime/histogram", dto); },
    };
};
//# sourceMappingURL=index.js.map